export default "__VITE_ASSET__24qitmpq__"